var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 26,
    viewBox: "0 0 14 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4784 22.9663L12.8059 22.6218L12.4784 22.2772L3.76607 13.1137L12.4783 3.95143L12.8058 3.60705L12.4785 3.26252L11.1876 1.90367L10.8253 1.52229L10.4628 1.90349L0.993039 11.8615L0.993029 11.8615L0.990484 11.8642C0.674189 12.2018 0.5 12.6502 0.5 13.1137C0.5 13.5772 0.674189 14.0255 0.990484 14.3631L0.990474 14.3631L0.993039 14.3658L10.4628 24.3239L10.8251 24.7049L11.1875 24.3238L12.4784 22.9663Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.88337d17b0cfa17121aad095e41fb66c.svg";
export { ForwardRef as ReactComponent };